import Container from '@mui/material/Container'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { ColdCard } from '@repo/shared-core-ui-components/ColdCard'
import Iconify from '@repo/shared-core-ui-components/Iconify/iconify'
import { useResponsive } from '@repo/shared-theme-utils/hooks/useResponsive'
import Image from 'next/image'
import TechnicalAnalysisImage from '../../../../public/assets/technical-analysis.png'

export function TechnicalAnalysisColdCard() {
  const theme = useTheme()
  const lgUp = useResponsive('up', 'lg')

  return (
    <Container maxWidth={false} sx={{ py: 5, maxWidth: '1544px' }}>
      <ColdCard
        variant={'full'}
        leftContent={
          <>
            <Typography variant={'h2'}>Technical analysis,</Typography>
            <Typography variant={'h2'} sx={{ marginBottom: 3 }}>
              done right
            </Typography>
            <Typography variant={'h6'} color="textSecondary" sx={{ marginBottom: 3 }}>
              Our platform comes with hundreds of pre-built studies, 50+ intelligent drawing tools and a set of tools for in-depth market analysis, covering the most
              popular trading concepts.
            </Typography>
            <ul style={{ textAlign: 'start', listStyle: 'none' }}>
              <li style={{ display: 'flex' }}>
                <Iconify icon={'ic:baseline-check'} sx={{ marginRight: 1 }} />
                <Typography variant={'h6'}>100+ pre-built most popular indicators</Typography>
              </li>
              <li style={{ display: 'flex' }}>
                <Iconify icon={'ic:baseline-check'} sx={{ marginRight: 1 }} />
                <Typography variant={'h6'}> 100,000+ community-built indicators</Typography>
              </li>
              <li style={{ display: 'flex' }}>
                <Iconify icon={'ic:baseline-check'} sx={{ marginRight: 1 }} />
                <Typography variant={'h6'}>50+ smart drawing tools</Typography>
              </li>
              <li style={{ display: 'flex' }}>
                <Iconify icon={'ic:baseline-check'} sx={{ marginRight: 1 }} />
                <Typography variant={'h6'}>Volume Profile indicators</Typography>
              </li>
              <li style={{ display: 'flex' }}>
                <Iconify icon={'ic:baseline-check'} sx={{ marginRight: 1 }} />
                <Typography variant={'h6'}>Candlestick patterns recognition</Typography>
              </li>
              <li style={{ display: 'flex' }}>
                <Iconify icon={'ic:baseline-check'} sx={{ marginRight: 1 }} />
                <Typography variant={'h6'}>Multi-timeframe analysis</Typography>
              </li>
            </ul>
          </>
        }
        rightContent={
          <Image
            alt="dashboard"
            src={TechnicalAnalysisImage}
            quality={75}
            style={{
              borderRadius: 'inherit',
              margin: 0,
              height: 'auto',
              maxHeight: 476,
              width: lgUp ? 'unset' : '100%',
              maxWidth: 'none'
            }}
          />
        }
      />
    </Container>
  )
}
